(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-image-and-text"] && !window.DesignMode) return;
  try {
    


jQuery( function($) {

	$('.popup-trigger').on('click', function() {

		$(this).siblings('.popup-content').addClass('visible');
		$('body').addClass('stop-scroll');

	});

	$('.popup-content .close').on('click', function() {
		$(this).parents('.popup-content').removeClass('visible');
		$('body').removeClass('stop-scroll');
	});



});


  } catch(e) { console.error(e); }
})();
      })();
